import type { MathColumn } from '../report/mathReportApi';

/** Идентификатор поля - имя колонки в записи: латиница, цифры и знак подчеркивания */
const FIELD_ID_PATTERN = /^[a-zA-Z0-9_]+$/;

export interface FieldErrors {
  field?: string;
  headerName?: string;
}

/** Пустая форма нового поля */
export const EMPTY_FIELD: MathColumn = { field: '', headerName: '', editable: false };

/** Проверка формы до отправки; сервер повторяет проверку на дубль идентификатора */
export function validateField(draft: MathColumn, isEditing: boolean, existing: MathColumn[]): FieldErrors {
  const errors: FieldErrors = {};
  const id = draft.field.trim();

  if (!id) {
    errors.field = 'Укажите идентификатор поля';
  } else if (!FIELD_ID_PATTERN.test(id)) {
    errors.field = 'Используйте только латинские буквы, цифры и знак _';
  } else if (!isEditing && existing.some((item) => item.field.toLowerCase() === id.toLowerCase())) {
    errors.field = 'Поле с таким идентификатором уже существует';
  }

  if (!draft.headerName.trim()) errors.headerName = 'Укажите заголовок поля';
  return errors;
}

export function hasErrors(errors: FieldErrors): boolean {
  return !!(errors.field || errors.headerName);
}

/** Поиск по идентификатору и заголовку */
export function filterFields(fields: MathColumn[], query: string): MathColumn[] {
  const needle = query.trim().toLowerCase();
  if (needle === '') return fields;
  return fields.filter(
    (item) => item.field.toLowerCase().indexOf(needle) >= 0 || item.headerName.toLowerCase().indexOf(needle) >= 0
  );
}
